/*
 * @Descripttion: 库存管理页面相关数据
 * @Author: 曹博
 * @Date: 2023-10-17 17:22:24
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-22 17:07:13
 */
import { ActionType, CustomAction } from '../../global'
import { fileFile, projectList } from '../../modules/uploadfiles/hooks'

export interface RegionalInventory {
  inventoryAmount: string
  sellArea: string
  stock: number
  sysRegionCodeName: string
}

export interface ProductSellAreaDTO {
  inventoryStatus: string
  code: string
  name: string
  manuCode: string
  unitName: string
  areaInventoryList: RegionalInventory[]
  sellArea?: string
  stock?: number
  onShelf: string
  productCode: string
  platformCode: string
  allAreaList: any
}

export interface State {
  dataSource: {
    data: ProductSellAreaDTO[]
    total: number
  }
  loading: boolean
  searchData: any
  pages: {
    pageNo: number
    pageSize: number
  }
  isReviseModalVisible: boolean
  reviseModalConfirmBtnLoading: boolean
  currentReviseMaterial: ProductSellAreaDTO
  isImportModalVisible: boolean
  isImportModalConfirmBtnLoading: boolean
  uploadFilesList: fileFile[]
  originFile: any
  projectOptions: projectList[]
  areaDataOptions: any
  flatDataOptions: any
  editLoading: boolean
}

export const initState: State = {
  dataSource: {
    data: [],
    total: 100,
  },
  loading: true,
  searchData: {},
  pages: {
    pageNo: 1,
    pageSize: 10,
  },
  isReviseModalVisible: false,
  reviseModalConfirmBtnLoading: false,
  currentReviseMaterial: {
    code: '',
    name: '',
    manuCode: '',
    unitName: '',
    areaInventoryList: [],
    productCode: '',
    onShelf: '',
    platformCode: '',
    inventoryStatus: '',
    allAreaList: [],
  },
  isImportModalVisible: false,
  isImportModalConfirmBtnLoading: false,
  uploadFilesList: [],
  originFile: {},
  projectOptions: [],
  areaDataOptions: [],
  flatDataOptions: [],
  editLoading: false,
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setPagesAction':
      newstate.pages = action.payload
      return newstate
    case 'setSearchDataAction':
      // 搜索 重置 分页
      newstate.searchData = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setIsReviseModalVisibleAction':
      newstate.isReviseModalVisible = action.payload
      return newstate
    case 'setReviseModalConfirmBtnLoadingAction':
      newstate.reviseModalConfirmBtnLoading = action.payload
      return newstate
    case 'setCurrentReviseMaterialAction':
      newstate.currentReviseMaterial = action.payload
      return newstate
    case 'setIsImportModalVisibleAction':
      newstate.isImportModalVisible = action.payload
      return newstate
    case 'setIsImportModalConfirmBtnLoadingAction':
      newstate.isImportModalConfirmBtnLoading = action.payload
      return newstate
    case 'setUploadFilesListAction':
      newstate.uploadFilesList = action.payload
      return newstate
    case 'setOriginFileAction':
      newstate.originFile = action.payload
      return newstate
    case 'setProjectOptionsAction':
      newstate.projectOptions = action.payload
      return newstate
    case 'setAreaDataOptionsAction':
      newstate.areaDataOptions = action.payload
      return newstate
    case 'setFlatDataOptionsAction':
      newstate.flatDataOptions = action.payload
      return newstate
    case 'setEditLoadingAction':
      newstate.editLoading = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置表格数据
 * @param param
 * @returns
 */
export const setDataSourceAction = (param: {
  dataSource: {
    data: any[]
    total: number
  }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 页面loading
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// 搜索
export const setSearchDataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchDataAction',
  payload: param,
})

// 修改库存弹框显隐
export const setIsReviseModalVisibleAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsReviseModalVisibleAction',
  payload: param,
})

// 修改库存弹框提交按钮loading
export const setReviseModalConfirmBtnLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setReviseModalConfirmBtnLoadingAction',
  payload: param,
})

// 当前修改的物料
export const setCurrentReviseMaterialAction = (
  param: ProductSellAreaDTO,
): CustomAction<Action> => ({
  type: 'setCurrentReviseMaterialAction',
  payload: param,
})

// 导入物料弹窗显隐
export const setIsImportModalVisibleAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsImportModalVisibleAction',
  payload: param,
})

// 导入物料弹窗提交按钮loading
export const setIsImportModalConfirmBtnLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsImportModalConfirmBtnLoadingAction',
  payload: param,
})

// 设置上传附件列表
export const setUploadFilesListAction = (
  param: fileFile[],
): CustomAction<Action> => ({
  type: 'setUploadFilesListAction',
  payload: param,
})

export const setProjectOptionsAction = (
  param: projectList[],
): CustomAction<Action> => ({
  type: 'setProjectOptionsAction',
  payload: param,
})

export const setAreaDataOptionsAction = (param: any): CustomAction<Action> => ({
  type: 'setAreaDataOptionsAction',
  payload: param,
})

export const setFlatDataOptionsAction = (param: any): CustomAction<Action> => ({
  type: 'setFlatDataOptionsAction',
  payload: param,
})

// 编辑框loading
export const setEditLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setEditLoadingAction',
  payload: val,
})

// 设置源文件
export const setOriginFileAction = (param: any): CustomAction<Action> => ({
  type: 'setOriginFileAction',
  payload: param,
})
/*
 * @Descripttion: 库存管理页面相关数据
 * @Author: 曹博
 * @Date: 2023-10-17 17:22:24
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-22 17:07:13
 */
import { ActionType, CustomAction } from '../../global'
import { fileFile, projectList } from '../../modules/uploadfiles/hooks'

export interface RegionalInventory {
  inventoryAmount: string
  sellArea: string
  stock: number
  sysRegionCodeName: string
}

export interface ProductSellAreaDTO {
  inventoryStatus: string
  code: string
  name: string
  manuCode: string
  unitName: string
  areaInventoryList: RegionalInventory[]
  sellArea?: string
  stock?: number
  onShelf: string
  productCode: string
  platformCode: string
  allAreaList: any
}

export interface State {
  dataSource: {
    data: ProductSellAreaDTO[]
    total: number
  }
  loading: boolean
  searchData: any
  pages: {
    pageNo: number
    pageSize: number
  }
  isReviseModalVisible: boolean
  reviseModalConfirmBtnLoading: boolean
  currentReviseMaterial: ProductSellAreaDTO
  isImportModalVisible: boolean
  isImportModalConfirmBtnLoading: boolean
  uploadFilesList: fileFile[]
  originFile: any
  projectOptions: projectList[]
  areaDataOptions: any
  flatDataOptions: any
  editLoading: boolean
}

export const initState: State = {
  dataSource: {
    data: [],
    total: 100,
  },
  loading: true,
  searchData: {},
  pages: {
    pageNo: 1,
    pageSize: 10,
  },
  isReviseModalVisible: false,
  reviseModalConfirmBtnLoading: false,
  currentReviseMaterial: {
    code: '',
    name: '',
    manuCode: '',
    unitName: '',
    areaInventoryList: [],
    productCode: '',
    onShelf: '',
    platformCode: '',
    inventoryStatus: '',
    allAreaList: [],
  },
  isImportModalVisible: false,
  isImportModalConfirmBtnLoading: false,
  uploadFilesList: [],
  originFile: {},
  projectOptions: [],
  areaDataOptions: [],
  flatDataOptions: [],
  editLoading: false,
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setPagesAction':
      newstate.pages = action.payload
      return newstate
    case 'setSearchDataAction':
      // 搜索 重置 分页
      newstate.searchData = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setIsReviseModalVisibleAction':
      newstate.isReviseModalVisible = action.payload
      return newstate
    case 'setReviseModalConfirmBtnLoadingAction':
      newstate.reviseModalConfirmBtnLoading = action.payload
      return newstate
    case 'setCurrentReviseMaterialAction':
      newstate.currentReviseMaterial = action.payload
      return newstate
    case 'setIsImportModalVisibleAction':
      newstate.isImportModalVisible = action.payload
      return newstate
    case 'setIsImportModalConfirmBtnLoadingAction':
      newstate.isImportModalConfirmBtnLoading = action.payload
      return newstate
    case 'setUploadFilesListAction':
      newstate.uploadFilesList = action.payload
      return newstate
    case 'setOriginFileAction':
      newstate.originFile = action.payload
      return newstate
    case 'setProjectOptionsAction':
      newstate.projectOptions = action.payload
      return newstate
    case 'setAreaDataOptionsAction':
      newstate.areaDataOptions = action.payload
      return newstate
    case 'setFlatDataOptionsAction':
      newstate.flatDataOptions = action.payload
      return newstate
    case 'setEditLoadingAction':
      newstate.editLoading = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置表格数据
 * @param param
 * @returns
 */
export const setDataSourceAction = (param: {
  dataSource: {
    data: any[]
    total: number
  }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 页面loading
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// 搜索
export const setSearchDataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchDataAction',
  payload: param,
})

// 修改库存弹框显隐
export const setIsReviseModalVisibleAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsReviseModalVisibleAction',
  payload: param,
})

// 修改库存弹框提交按钮loading
export const setReviseModalConfirmBtnLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setReviseModalConfirmBtnLoadingAction',
  payload: param,
})

// 当前修改的物料
export const setCurrentReviseMaterialAction = (
  param: ProductSellAreaDTO,
): CustomAction<Action> => ({
  type: 'setCurrentReviseMaterialAction',
  payload: param,
})

// 导入物料弹窗显隐
export const setIsImportModalVisibleAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsImportModalVisibleAction',
  payload: param,
})

// 导入物料弹窗提交按钮loading
export const setIsImportModalConfirmBtnLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsImportModalConfirmBtnLoadingAction',
  payload: param,
})

// 设置上传附件列表
export const setUploadFilesListAction = (
  param: fileFile[],
): CustomAction<Action> => ({
  type: 'setUploadFilesListAction',
  payload: param,
})

export const setProjectOptionsAction = (
  param: projectList[],
): CustomAction<Action> => ({
  type: 'setProjectOptionsAction',
  payload: param,
})

export const setAreaDataOptionsAction = (param: any): CustomAction<Action> => ({
  type: 'setAreaDataOptionsAction',
  payload: param,
})

export const setFlatDataOptionsAction = (param: any): CustomAction<Action> => ({
  type: 'setFlatDataOptionsAction',
  payload: param,
})

// 编辑框loading
export const setEditLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setEditLoadingAction',
  payload: val,
})

// 设置源文件
export const setOriginFileAction = (param: any): CustomAction<Action> => ({
  type: 'setOriginFileAction',
  payload: param,
})
